import z from "zod";
import {
  DeviceConfigIdScheme,
  PrepStationIdScheme,
  PrinterIdScheme,
  TableIdScheme,
} from "./ids";
import { PrepStationScope } from "./enums/PrepStationScope";
import { ServingScope } from "./enums/ServingScope";
import { CatalogOrigin } from "./enums/CatalogOrigin";

const PrepStationPrinterOverrideScheme = z.object({
  printerIds: z.array(PrinterIdScheme),
  tableIds: z.array(TableIdScheme).optional(),
  deviceConfigIds: z.array(DeviceConfigIdScheme).optional(),
  isEnabled: z.boolean().optional(),
});

export const PrepStationDBScheme = z.object({
  id: PrepStationIdScheme,
  name: z.string(),
  printerIds: z.array(PrinterIdScheme),
  printerOverrides: z.array(PrepStationPrinterOverrideScheme).optional(),
  servingScope: z.enum(ServingScope),
  prepStationScope: z.enum(PrepStationScope),
  simplifyItemsFromOtherPrepStations: z.boolean(),
  isMaster: z.boolean().optional(),
  mirroredPrepStationIds: z.array(PrepStationIdScheme).optional(),
  requireReference: z.boolean().optional().nullable(),
  onePrepTicketPerCourse: z.boolean().optional(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetPrepStation = PrepStationDBScheme;

export const RestCreatePrepStation = PrepStationDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const RestUpdatePrepStation = RestCreatePrepStation.partial();

export type DBPrepStation = z.infer<typeof PrepStationDBScheme>;
export type RestPrepStation = z.infer<typeof RestGetPrepStation>;
export type RestCreatePrepStation = z.infer<typeof RestCreatePrepStation>;
export type RestUpdatePrepStation = z.infer<typeof RestUpdatePrepStation>;
